import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";

interface CtaBandProps {
  heading?: string;
  subheading?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

export function CtaBand({
  heading = "Ready to staff your digital team?",
  subheading = "Spin up your workspace in under two minutes. Hire your first agent today.",
  primaryLabel = "Get started",
  primaryHref = "/register",
  secondaryLabel,
  secondaryHref,
}: CtaBandProps) {
  const primaryInternal = primaryHref.startsWith("/");
  const secondaryInternal = secondaryHref?.startsWith("/");
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-violet via-[#5B21B6] to-[#1E1B4B]" aria-hidden />
      <div
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(0,212,255,0.15),transparent_55%)]"
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 py-20 md:py-28">
        <div className="max-w-3xl">
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-white leading-[1.02]">
            {heading}
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/80 max-w-xl">{subheading}</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button asChild size="lg" className="bg-white text-brand-violet hover:bg-white/90">
              {/* TODO: track event — cta_band_primary_click */}
              {primaryInternal ? (
                <Link to={primaryHref}>
                  {primaryLabel}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              ) : (
                <a href={primaryHref}>
                  {primaryLabel}
                  <ArrowRight className="h-4 w-4" />
                </a>
              )}
            </Button>
            {secondaryLabel && secondaryHref && (
              <Button asChild size="lg" variant="outline" className="border-white/30 text-white hover:bg-white/10">
                {secondaryInternal ? (
                  <Link to={secondaryHref}>{secondaryLabel}</Link>
                ) : (
                  <a href={secondaryHref}>{secondaryLabel}</a>
                )}
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
